<template>
    <div id="wrapper">
        <Top></Top>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">ソフトウェア受託開発</h2>
                    </div>
                </div>
            </div>
            </section>
            <section id="content">
            <div class="container">
                            
                            <div class="about">
                        
                                <section class="features">
                <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div><h2>ソフトウェア受託開発</h2>お客様や社会に暮らす人々に、より安心・安全そして快適・便利なソリューションを享受できるように、OSから通信インタフェース、ネットワークの<br>
                        管理運用といったミドルウェア、さらにはアプリケーションにいたるまで幅広いソフトウェアを対象として開発に取り組みます。</div>
                        <br>
                    </div>
                </div>
                
                  <div class="row">         
                    <div class="col-md-6">
                      <div class="features-item">
                        <div class="features">
                          <div class="icon">
                           <i class="icon-map icons"></i>
                          </div>
                          <div class="features-content">
                            <h3>準委任契約開発</h3>
                            <p>システム企画、要件定義など、上流工程から対応できます。システム全体像明確してない段階に、適用する契約方式。</p>
                          </div>
                        </div>
                        <div class="features">
                          <div class="icon">
                            <i class="icon-badge icons"></i>
                          </div>
                          <div class="features-content">
                            <h3>請負契約開発</h3>
                            <p>機能設計、詳細設計以降工程から最適な契約方式。</p>
                            <br>
                          </div>
                        </div>
                        <div class="features">
                          <div class="icon">
                            <i class="icon-envelope-open icons"></i>
                          </div>
                          <div class="features-content">
                            <h3>オフショア請負契約開発</h3>
                            <p>詳細設計以降の製造、単体テスト工程メインとして、品質確保の上、低コストで対応できます。</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <img class="img-responsive" src="../assets/img/img1.png" alt="">
                    </div>
                  </div>
                </div>
                
              <div class="row">
                    <div class="col-md-12">
                        <div><h2>当社技術割合</h2></div>
                        <br/>
                    </div>
                    <div class="team-six">
                        <div class="row">
                            <div class="col-md-3 col-sm-6">
                                <!-- Team Member -->
                                <div class="team-member">
                                    <!-- Image -->
                                    <img class="img-responsive" src="../assets/img/tech/image_LANG.png" alt="" style="width:270px;height:270px">
                                    <!-- Name -->
                                    <h4>言語</h4>
                                    <span class="deg">2019年6月</span> 
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <!-- Team Member -->
                                <div class="team-member">
                                    <!-- Image -->
                                    <img class="img-responsive" src="../assets/img/tech/image_OS.png" alt="" style="width:270px;height:270px">
                                    <!-- Name -->
                                    <h4>ＯＳ</h4>
                                    <span class="deg">2019年6月</span> 
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <!-- Team Member -->
                                <div class="team-member">
                                    <!-- Image -->
                                    <img class="img-responsive" src="../assets/img/tech/image_DB.png" alt="" style="width:270px;height:270px">
                                    <!-- Name -->
                                    <h4>データベース</h4>
                                    <span class="deg">2019年6月</span> 
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <!-- Team Member -->
                                <div class="team-member">
                                    <!-- Image -->
                                    <img class="img-responsive" src="../assets/img/tech/image_GM.png" alt="" style="width:270px;height:270px">
                                    <!-- Name -->
                                    <h4>業務</h4>
                                    <span class="deg">2019年6月</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </section>
                </div>
            </div>
            </section>
            
                <section id="content">
                <div class="container content">	
                <div class="row">
                    <div class="col-md-12">
                        <div>
                            <h2>開発実績</h2>
                        </div>
                    </div>
                </div>		
                <hr class="margin-bottom-50">
                <!-- Info Blcoks -->
                <div class="row">
                    <div class="col-sm-4 info-blocks">
                        <i class="icon-info-blocks fa fa-user"></i>
                        <div class="info-blocks-in">
                            <h3>eラーニングシステム</h3>
                            <p>オンライン教育システム<br>
                               開発言語：Java、JavaScript、JSP<br>
                               開発環境：SSM+MySQL8.0<br>
                               詳細情報は下記URLを参照してください。<br>
                               <a href="http://www.asatex.jp/ITTrainNet">http://www.asatex.jp/ITTrainNet</a></p>
                        </div>
                    </div>
                    <div class="col-sm-4 info-blocks">
                        <i class="icon-info-blocks fa fa-star"></i>
                        <div class="info-blocks-in">
                            <h3>ＰＪ２</h3>
                            <p>進行中．．．</p>
                        </div>
                    </div>
                    <div class="col-sm-4 info-blocks">
                        <i class="icon-info-blocks fa fa-book"></i>
                        <div class="info-blocks-in">
                            <h3>ＰＪ３</h3>
                            <p>進行中．．．</p>
                        </div>
                    </div>
                </div>
                <!-- End Info Blcoks -->
                <!-- Info Blcoks -->
                <div class="row">
                    <div class="col-sm-4 info-blocks">
                        <i class="icon-info-blocks fa fa-home"></i>
                        <div class="info-blocks-in">
                            <h3>ＰＪ４</h3>
                            <p>進行中．．．</p>
                        </div>
                    </div>
                    <div class="col-sm-4 info-blocks">
                        <i class="icon-info-blocks fa fa-flag-o"></i>
                        <div class="info-blocks-in">
                            <h3>ＰＪ５</h3>
                            <p>進行中．．．</p>
                        </div>
                    </div>
                    <div class="col-sm-4 info-blocks">
                        <i class="icon-info-blocks fa fa-thumbs-o-up"></i>
                        <div class="info-blocks-in">
                            <h3>ＰＪ６</h3>
                            <p>進行中．．．</p>
                        </div>
                    </div>
                </div>
                <!-- End Info Blcoks -->
        
                
            </div>
            </section>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>